export enum Errors {
  LoadTodo = 'Unable to load todos',
  EmptyTodoTitle = 'Title should not be empty',
  AddTodo = 'Unable to add a todo',
  DeleteTodo = 'Unable to delete a todo',
  UpdateTodo = 'Unable to update a todo',
}
